let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("amXVC")).then(() => parcelRequire('1K9B4'));